//Elastic Search will send up text highlighted with <em> to display in the search.
//However this requires dangerously rendering the html, which is a vulnerability
//This function is meant to replicate the functionality in a safe way
//It expects a string with any number of <em></em> pairs
export const handleHighlight = (string: string) => {
    //Turns the string into an array with highlighted sections seperated from the non highlighted sections
    const split = string.split(/<em>|<\/em>/);

    //The format of the resulting array allows us to just alternate nonhighlighted -> highlighted -> nonhighlighted for any number of pairs
    return (
        <span>
            {split.map((string, index)=>{
                if (index % 2 === 0) {
                    return <>{string}</>;
                } else {
                    return <em key={index}>{string}</em>;
                }
            })}
        </span>
    );
};
